module.exports = __webpack_public_path__ + "static/media/make_over_logo_big.b0d004f3.png";